import React, { useState } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import ActionLink from '../builder/ActionLink';
import ActionButton from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection.js';
import SaveButton from '../builder/SaveButton';
import FloatingLayer from '../builder/FloatingLayer';
import Message from '../builder/Message';
import SectionSubtitle from '../builder/SectionSubtitle';
import SectionTitle from '../builder/SectionTitle';
import { ProfileModule } from '../ui_items/Module.js';
import { useOwner } from '../context/context.js';

const Wrapper = (props) => {
	const is_builder = props?.is_builder ?? false;

	if(is_builder) {
		return props.children;
	}

	return (
		<ProfileModule _class={{ padding:false }}>
			{props.children}
		</ProfileModule>
	)
};

const PromoMainInfo = (props) => {
	const owner = useOwner();

	const [ display_warning_upgrade, setDisplayWarningUpgrade ] = useState(false);
	
	const promotion = owner?.promotion?.Promotion ?? false;
	if(promotion === false) return null;
	
	const is_basic = (promotion.promo_type == '0') ? true : false;
	const status = owner?.status ?? 'draft';
	
	if(!is_basic || status == 'old' || status == 'expired') return null;
	
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	
	const currency = props?.currency ?? 'USD';

	const upgrade_price = props?.upgrade_price ?? {};

	let _upgrade_price = 0;
	_upgrade_price = upgrade_price[currency] != undefined ? upgrade_price[currency] : null;
	let upgrade_price_curr = '';
	switch(currency) {
		case 'EUR':
			upgrade_price_curr = _upgrade_price+' €';
			break;

		case 'USD':
		default:
			upgrade_price_curr = '$'+_upgrade_price+' USD';
			break;
	}

	return (
		<Wrapper is_builder={props.is_builder}>
			<Message
				title={i18n("***Upgrade to Premium")}
				icon='ep-addon'
				autotranslate={false}
				_class={{ other:'addons_information in_top in_bottom' }}
			>
				<p><FormattedMessage id="You can upgrade your promotion to Premium version for {price} to get access to the Premium design template, emails platform, full customization of the registration form, Multi-Network Giveaway and advanced statistics, among others. You can review all the advantages of the Premium version {link}." values={{price:<strong>{upgrade_price_curr}</strong>, link:<ActionLink _href={`${window.web_base_url}${(window.is_spanish) ? 'precios-planes-apps/' : 'pricing-plans-apps/'}`} _target="_blank">here</ActionLink>}} /></p>

				<ButtonCollection _class={{other:'not_in_top'}}>
					<ActionButton
						onClick={() => setDisplayWarningUpgrade(true)}
						color="premium"
					>Upgrade to Premium</ActionButton>
				</ButtonCollection>
			</Message>

			{(display_warning_upgrade) && (
				<FloatingLayer _class={{size:'small'}} backButton={() => setDisplayWarningUpgrade(false)}>
					<div>
						<SectionTitle _class={{icon:'knk-alert', other:'redIcon'}}>Warning</SectionTitle>

						<SectionSubtitle>If you continue you can't return to the Basic Version.</SectionSubtitle>

						<SectionSubtitle>Are you sure you want to continue?</SectionSubtitle>

						<ButtonCollection in_floating={true}>
							<SaveButton
								_href={`/promotions/upgrade/${promotion.id}`}
							>Continue</SaveButton>

							<ActionLink
								onClick={() => setDisplayWarningUpgrade(false)}
							>Cancel</ActionLink>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}
		</Wrapper>
	);
}

export default injectIntl(PromoMainInfo);